import { useMutation, useQuery } from "@tanstack/react-query";

import { get, post } from "./client";
import type { ApiResponse } from "./deals";

export type AiOutputFeedbackOutputType = "ai_insight" | "chatbot_message";
export type AiOutputFeedbackSentiment = "up" | "down";

export interface FeedbackReasonDto {
  id: number;
  reasonCode: string;
  displayText: string;
  applicableTo: AiOutputFeedbackOutputType | "both";
  isActive: boolean;
  createdDate: string;
  modifiedDate?: string | null;
}

export interface SubmitAiOutputFeedbackRequest {
  executionId: number;
  sentiment: AiOutputFeedbackSentiment;
  reasonCode?: string;
  explanationText?: string;
}

export interface FeedbackSubmittedDto {
  feedbackId: number;
  executionId: number;
  sentiment: AiOutputFeedbackSentiment;
  reasonCode?: string | null;
}

const aiOutputFeedbackQueryKeys = {
  reasons: ["ai-output-feedback-reasons"] as const,
};

export function useAiOutputFeedbackReasons(enabled: boolean) {
  return useQuery({
    queryKey: aiOutputFeedbackQueryKeys.reasons,
    queryFn: () => get<ApiResponse<FeedbackReasonDto[]>>("/ai-output-feedback-reasons"),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}

export function useSubmitAiOutputFeedback() {
  return useMutation({
    mutationFn: (request: SubmitAiOutputFeedbackRequest) =>
      post<ApiResponse<FeedbackSubmittedDto>>("/ai-output-feedback", request),
  });
}
